export interface IBeacontypeProps {
  id: string
  name: string
  order: number
}

export default class BeacontypeEntity {
  private _props: IBeacontypeProps

  constructor(props: IBeacontypeProps) {
    this._props = props
  }

  get props(): IBeacontypeProps {
    return this._props
  }

  get id(): string {
    return this._props.id
  }

  get name(): string {
    return this._props.name
  }

  get order(): number {
    return this._props.order
  }
}

export const headers = [
  { text: 'ID', value: 'id' },
  { text: 'タイプ', value: 'name' },
  { text: '順番', value: 'order' },
  { text: '', value: 'actions', sortable: false, width: '80' }
]

export const EmptyBeacontypePropsFactory = (props?: Partial<IBeacontypeProps>): IBeacontypeProps => ({
  id: '',
  name: '',
  order: 0,
  ...props
})

export const BeacontypePropsFactory = (props?: Partial<IBeacontypeProps>): IBeacontypeProps => ({
  id: 'unique_beacontype_id',
  name: 'タイプ',
  order: 1,
  ...props
})

export const EmptyBeacontypeEntityFactory = (props?: Partial<IBeacontypeProps>): BeacontypeEntity => {
  return new BeacontypeEntity(EmptyBeacontypePropsFactory(props))
}

export const BeacontypeEntityFactory = (props?: Partial<IBeacontypeProps>): BeacontypeEntity => {
  return new BeacontypeEntity(BeacontypePropsFactory(props))
}
